import React, {
  useRef,
  useState,
  useEffect
} from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";

export const AgregarCurso = (props) => {
  // Refs para todos los campos del formulario según el orden del Java
  const txtDescripcion = useRef(null);
  const txtInstitucion = useRef(null);
  const txtDuracion = useRef(null);
  const cmbMes = useRef(null);
  const txtAnio = useRef(null);
  const txtObservacion = useRef(null);

  // Estado para el modo de operación (1: nuevo, 2: editar, 4: consultar)
  const [operacion, setOperacion] = useState(props.operacion);

  // Estado para controlar validaciones
  const [errores, setErrores] = useState({});

  // Opciones de meses (igual que en Java)
  const opcionesMeses = [
    "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
    "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
  ];

  // Función para llenar campos cuando se edita o consulta
  const llenarCampos = (datos) => {
    if (!datos) return;

    console.log('Datos a llenar en modal curso:', datos); // Para depuración

    // Mes (índice 0 en el Java)
    if (cmbMes.current && datos[0]) {
      cmbMes.current.value = datos[0];
    }

    // Año (índice 1 en el Java)
    if (txtAnio.current && datos[1]) {
      txtAnio.current.value = datos[1];
    }

    // Duración (índice 2 en el Java)
    if (txtDuracion.current && datos[2]) {
      txtDuracion.current.value = datos[2];
    }

    // Descripción (índice 3 en el Java)
    if (txtDescripcion.current && datos[3]) {
      txtDescripcion.current.value = datos[3];
    }

    // Institución (índice 4 en el Java)
    if (txtInstitucion.current && datos[4]) {
      txtInstitucion.current.value = datos[4];
    }

    // Observación (índice 5 en el Java)
    if (txtObservacion.current && datos[5]) {
      txtObservacion.current.value = datos[5];
    }
  };

  // Efecto para cargar datos cuando se edita o consulta
  useEffect(() => {
    setOperacion(props.operacion);

    if (props.datos && (props.operacion === 2 || props.operacion === 4)) {
      // Llamar a llenarCampos cuando se reciben datos
      setTimeout(() => {
        llenarCampos(props.datos);
      }, 100); // Pequeño retraso para asegurar que los refs estén listos

      if (props.operacion === 4) {
        deshabilitarCampos();
      } else if (props.operacion === 2) {
        habilitarCampos();
      }
    }
  }, [props.datos, props.operacion]);

  const deshabilitarCampos = () => {
    const campos = [txtDescripcion, txtInstitucion, txtDuracion, cmbMes, txtAnio, txtObservacion];
    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = true;
    });
  };

  const habilitarCampos = () => {
    const campos = [txtDescripcion, txtInstitucion, txtDuracion, cmbMes, txtAnio, txtObservacion];
    campos.forEach(campo => {
      if (campo.current) campo.current.disabled = false;
    });
  };

  const validarCampos = () => {
    const nuevosErrores = {};
    let valido = true;

    // Validar descripción (obligatorio como en Java)
    if (!txtDescripcion.current?.value?.trim()) {
      nuevosErrores.descripcion = "La descripción del curso no debe estar en blanco";
      valido = false;
      txtDescripcion.current?.focus();
    }

    // Validar institución (obligatorio como en Java)
    if (!txtInstitucion.current?.value?.trim()) {
      nuevosErrores.institucion = "La institución no debe estar en blanco";
      valido = false;
      if (!nuevosErrores.descripcion) txtInstitucion.current?.focus();
    }

    // Validar duración (obligatorio como en Java)
    if (!txtDuracion.current?.value?.trim()) {
      nuevosErrores.duracion = "La duración del curso no debe estar en blanco";
      valido = false;
      if (!nuevosErrores.descripcion && !nuevosErrores.institucion) txtDuracion.current?.focus();
    }

    // Validar mes (obligatorio como en Java)
    if (!cmbMes.current?.value) {
      nuevosErrores.mes = "El mes no debe estar en blanco";
      valido = false;
      if (!nuevosErrores.descripcion && !nuevosErrores.institucion && !nuevosErrores.duracion) cmbMes.current?.focus();
    }

    // Validar año (obligatorio como en Java)
    if (!txtAnio.current?.value?.trim()) {
      nuevosErrores.anio = "El año no debe estar en blanco";
      valido = false;
      if (!nuevosErrores.descripcion && !nuevosErrores.institucion && !nuevosErrores.duracion && !nuevosErrores.mes) txtAnio.current?.focus();
    } else if (!/^\d{4}$/.test(txtAnio.current.value)) {
      nuevosErrores.anio = "El año debe tener 4 dígitos";
      valido = false;
      if (!nuevosErrores.descripcion && !nuevosErrores.institucion && !nuevosErrores.duracion && !nuevosErrores.mes) txtAnio.current?.focus();
    }

    setErrores(nuevosErrores);
    return valido;
  };

  const aceptar = () => {
    if (operacion === 1 || operacion === 2) {
      if (!validarCampos()) {
        return;
      }
    }

    // Construir objeto con los datos en el mismo orden que Java
    const datosCurso = {
      mes: cmbMes.current?.value || "",
      anio: txtAnio.current?.value || "",
      duracion: txtDuracion.current?.value?.toUpperCase() || "",
      descripcion: txtDescripcion.current?.value?.toUpperCase() || "",
      institucion: txtInstitucion.current?.value?.toUpperCase() || "",
      observacion: txtObservacion.current?.value?.toUpperCase() || ""
    };

    console.log('Datos del curso a enviar:', datosCurso);

    // Devolver los datos al componente padre
    if (props.onAceptar) {
      props.onAceptar(datosCurso);
    }

    props.onHide();
  };

  const cancelar = () => {
    // Limpiar campos
    if (txtDescripcion.current) txtDescripcion.current.value = '';
    if (txtInstitucion.current) txtInstitucion.current.value = '';
    if (txtDuracion.current) txtDuracion.current.value = '';
    if (cmbMes.current) cmbMes.current.value = '';
    if (txtAnio.current) txtAnio.current.value = '';
    if (txtObservacion.current) txtObservacion.current.value = '';

    props.onHide();
  };

  console.log('Datos recibidos en curso:', props.datos || 'No hay datos');

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);

        if (props.operacion === 1) {
          // Limpiar campos para nuevo registro
          if (txtDescripcion.current) txtDescripcion.current.value = '';
          if (txtInstitucion.current) txtInstitucion.current.value = '';
          if (txtDuracion.current) txtDuracion.current.value = '';
          if (cmbMes.current) cmbMes.current.value = '';
          if (txtAnio.current) txtAnio.current.value = '';
          if (txtObservacion.current) txtObservacion.current.value = '';
          if (txtDescripcion.current) txtDescripcion.current.focus();
        } else if (props.datos) {
          // Para edición o consulta, llenar los campos
          setTimeout(() => {
            llenarCampos(props.datos);

            if (props.operacion === 4) {
              deshabilitarCampos();
            } else if (props.operacion === 2) {
              habilitarCampos();
            }
          }, 100);
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 1 && "Incluir Curso-Taller"}
          {operacion === 2 && "Editar Curso-Taller"}
          {operacion === 4 && "Consultar Curso-Taller"}
        </h3>
        <a type="button" onClick={cancelar} style={{ cursor: 'pointer' }}>
          salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center">
          <legend className="float-none m-0 w-auto">Datos del Curso-Taller</legend>

          {/* Mostrar errores de validación */}
          {Object.keys(errores).length > 0 && (
            <div className="alert alert-danger col-12" role="alert">
              {Object.values(errores).map((error, index) => (
                <div key={index}>• {error}</div>
              ))}
            </div>
          )}

          <div className="col-md-12 px-0 mx-auto row">
            {/* Descripción - Primer campo según el orden de Java */}
            <div className="input-group input-group-sm mb-3 col-md-12">
              <span className="input-group-text" style={{ width: '120px' }}>Descripción:</span>
              <input
                type="text"
                className="form-control"
                ref={txtDescripcion}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                maxLength="200"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtInstitucion.current?.focus();
                }}
              />
            </div>

            {/* Institución - Segundo campo */}
            <div className="input-group input-group-sm mb-3 col-md-12">
              <span className="input-group-text" style={{ width: '120px' }}>Institución:</span>
              <input
                type="text"
                className="form-control"
                ref={txtInstitucion}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                maxLength="150"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtDuracion.current?.focus();
                }}
              />
            </div>

            {/* Duración - Tercer campo */}
            <div className="input-group input-group-sm mb-3 col-md-6">
              <span className="input-group-text" style={{ width: '120px' }}>Duración:</span>
              <input
                type="text"
                className="form-control"
                ref={txtDuracion}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                maxLength="50"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') cmbMes.current?.focus();
                }}
              />
            </div>

            {/* Mes - Cuarto campo */}
            <div className="input-group input-group-sm mb-3 col-md-6">
              <span className="input-group-text" style={{ width: '120px' }}>Mes:</span>
              <select
                className="form-select"
                ref={cmbMes}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtAnio.current?.focus();
                }}
              >
                <option value="">Seleccione...</option>
                {opcionesMeses.map(mes => (
                  <option key={mes} value={mes}>{mes}</option>
                ))}
              </select>
            </div>

            {/* Año - Quinto campo */}
            <div className="input-group input-group-sm mb-3 col-md-6">
              <span className="input-group-text" style={{ width: '120px' }}>Año:</span>
              <input
                type="text"
                className="form-control"
                ref={txtAnio}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                maxLength="4"
                placeholder="AAAA"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') txtObservacion.current?.focus();
                }}
              />
            </div>

            {/* Observación - Sexto campo */}
            <div className="input-group input-group-sm mb-3 col-md-12">
              <span className="input-group-text" style={{ width: '120px' }}>Observación:</span>
              <textarea
                rows="3"
                className="form-control"
                ref={txtObservacion}
                disabled={operacion === 4 || operacion === 3 ? true : false}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) aceptar();
                }}
              />
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {(operacion === 1 || operacion === 2) && (
          <button
            type="button"
            className="btn btn-sm rounded-pill col-md-2 btn-success"
            onClick={aceptar}
          >
            Aceptar
          </button>
        )}
        <button
          type="button"
          onClick={cancelar}
          className="btn btn-sm rounded-pill col-md-2 btn-danger"
        >
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};